var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"dashboard-content-container container"},[_c('UserProducts',{attrs:{"userProducts":_vm.userProducts,"isUpdatesCard":_vm.isUpdatesCard}}),_c('DashboardUpdatesCard',{on:{"updatesCardVisibility":_vm.updateLayout}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }